import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
export default {
  name: 'SanityTable',
  components: {
    SanityBlockContent
  },
  props: {
    header: Object,
    body: Object,
    footer: Object,
    selected: String,
    alignment: {
      type: String,
      default: 'justify-center'
    }
  },
  beforeMount() {
    if (this.selected) {
      const columns = this.$el.querySelectorAll(`.table-alt .table-alt-row .table-alt-col:nth-child(${this.selected})`);
      columns.forEach(col => col.classList.add('selected'));
      const mobileColumns = this.$el.querySelectorAll(`.table-alt-mobile .table-alt-row .table-alt-col:nth-child(${this.selected})`);
      mobileColumns.forEach(col => col.classList.add('selected'));
      if (!this.footer || this.footer.rows.length < 1) {
        const lastRow = this.$el.querySelector('.table-alt .table-alt-row:last-child');
        lastRow.classList.add('table-alt-row__final');
        const lastMobileRow = this.$el.querySelector('.table-alt-mobile .table-alt-row:last-child');
        lastMobileRow.classList.add('table-alt-row__final');
      }
    }
  }
};